import React from "react";
import * as styles from "../tag/tag.module.scss";

/**
 * @type {Object} 「UI:atoms - リスト タグ一覧 コンポーネント」DOMです。
 * @return {Object} DOMを返します。
 * @param {Array} children 子コンポーネントを受け取るための引数です。任意の要素を渡します。
 *
 */

const Tags = ({ children }) => {
  return <ul className={`${styles.tagList}`}>{children}</ul>;
};

export default Tags;
